  const API_BASE_URL = process.env.REACT_APP_API_URL
  console.log(" pi bas eurl ", API_BASE_URL)


export async function getProducts() {
  const res = await fetch(`${API_BASE_URL}/get-all-products`, {
    method: "GET"
  });

  if (!res.ok) throw new Error("Erreur dans la recueration des produits");
  return res.json();
}


export async function getProductsByCategory(data) {
  const res = await fetch(`${API_BASE_URL}/get-product/${data}`, {
    method: "GET"
  });
  if (!res.ok) throw new Error("Erreur dans la recueration des produits");
  return res.json();
}


export async function getCategories() {
  const res = await fetch(`${API_BASE_URL}/get-categories`, {
    method: "GET"
  });
  if (!res.ok) throw new Error("Erreur dans la recueration des categories");
  return res.json();
}


export async function getDetails(productID) {
  const res = await fetch(`${API_BASE_URL}/product/get-details/${productID}`, {
    method: "GET" 
  });
  if (!res.ok) throw new Error("Erreur dans la recueration des categories");
  return res.json();
}

export async function newContact(payload){
  const res = await fetch(`${API_BASE_URL}/new-contact`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify(payload), 
        });
      if (!res.ok) throw new Error("Erreur dans la creation du product");
  return res.json();
}

export async function getSettings() {
  const res = await fetch(`${API_BASE_URL}/options`, {
    method: "GET" 
  });
  if (!res.ok) throw new Error("Erreur dans la recueration des categories");
  return res.json();
}

export async function trackVisit(pageType, productId = null){
  const res = await fetch(`${API_BASE_URL}/statistics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify({ pageVisited: pageType, productId }),
        });
      if (!res.ok) throw new Error("Erreur dans la creation du product");
  return res.json();
}


